import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

export const styleProps = {
  size: "text-base",
  leading: "leading-6",
  tracking: "tracking-tighter",
};

export interface BodyMdProps extends TextInternalProps {
  "data-testid"?: string;
}

export const BodyMd = ({
  color,
  textAlign,
  truncate,
  [DATA_TESTID]: dataTestId,
  children,
  ...otherProps
}: BodyMdProps) => {
  const props = {
    ...styleProps,
    color,
    textAlign,
    truncate,
    dataTestId,
    ...otherProps,
  };

  return (
    <Text_INTERNAL as="p" {...props}>
      {children}
    </Text_INTERNAL>
  );
};
